import React from "react";
import { AddCustodianMasterContainer } from "../../../containers";

const AddCustodianMaster = (props) => {
  return <AddCustodianMasterContainer {...props} />;
};

export default AddCustodianMaster;
